/*
 * Title: Rewards/RedeemContent.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Redeem Content page content listing, click on list popup will shows from bottom.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import React from "react";
import { connect } from "react-redux";
import { motion } from "framer-motion";
import RedeemContentItem from "./RedeemContentItem";
import Loader from "@components/Loader";

const animations = {
  initial: { opacity: 0, x: 100 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -100 },
};
type Props = {};
type MyState = {
  toggleHeight: boolean;
};
class RedeemContent extends React.Component<Props | any, MyState> {
  state: MyState = {
    toggleHeight: false,
  };

  toggleHandler = () => {
    this.setState({ toggleHeight: !this.state.toggleHeight });
  };

  fetchRedeemRewards = () => {
    if (this.props.programId) {
      this.props.fetchRedeemRewards(this.props.programId);
      this.props.fetchScores(this.props.programId);
    }
  }

  componentDidUpdate(
    prevProps: Readonly<any>,
    prevState: Readonly<MyState>,
    snapshot?: any
  ): void {
    if (this.props.creatorData?.id != prevProps.creatorData?.id) {
      this.props.fetchRedeemRewards(this.props.creatorData?.id);
      this.props.fetch(this.props.creatorData?.id);
    }
  }

  render() {

    const unavailable = (this.props.touchpoints?.rewards || []).filter(i=>i.numRedemptions==i.reward?.limit && i?.reward?.active);
    const available = (this.props.touchpoints?.rewards || []).filter(i=>i.numRedemptions!=i.reward?.limit && i?.reward?.active);
    return (
      <div
        className="space-y-3 overflow-y-auto overflow-x-hidden pt-8 px-1 lg:h-[calc(100vh-265px)] lg:pb-[100px] pb-[30px]"
        id="scrollbar">
        <motion.div
          variants={animations}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.5 }}>
          <div>
            {this.props.isFetching && (
              <Loader height={30} width={30} white={true} />
            )}
              <>
              {(available || []).length>0 &&
              <p className="tile-inlay-primary opacity-50 lg:text-[15px] text-[13px] uppercase font-semibold tracking-wider mt-2 mb-2">
                     {"Available"}
                    </p>
                }
              <div className="space-y-[15px] ">
              {(available || []).map((reward, key) => {
                  return <RedeemContentItem fetch={this.fetchRedeemRewards} user={this.props.user} creatorId={this.props.assets.creatorId} item={reward} key={key} points_redeemed={this.props.points_redeemed} />;
                })}
                  </div>
                  {(unavailable || []).length>0 &&
                 <p className="tile-inlay-primary opacity-50 lg:text-[15px] text-[13px] uppercase font-semibold tracking-wider mt-2 mb-2">
                     {"UnAvailable"}
                    </p>
                  }
              <div className="space-y-[15px] ">
                {(unavailable || []).map((reward, key) => {
                  return <RedeemContentItem fetch={this.fetchRedeemRewards} user={this.props.user} creatorId={this.props.assets.creatorId} item={reward} key={key} points_redeemed={this.props.points_redeemed} />;
                })}
              </div>
              
              </>
          </div>
        </motion.div>
      </div>
    );
  }
}

const mapStateToProps = ({ creator, RedeemReward, user, score }) => {
  return {
    creatorData: creator?.creator,
    assets: creator.assets,
    touchpoints: RedeemReward.data,
    isFetching: RedeemReward.isFetching,
    points_redeemed: score.points_redeemed,
    user:user?.user?.user,
    programId:creator.program?.id
  };
};

const mergeProps = (stateProps: any, dispatchProps: any) => {
  const { dispatch } = dispatchProps;
  const { redeemRewardActions } = require("@redux/RedeemRewardRedux");
  const { actions } = require("@redux/ScoreRedux");
  return {
    ...stateProps,
    fetchRedeemRewards: (creatorId) => {
      redeemRewardActions.fetchRedeemRewards(dispatch, creatorId);
    },
    fetchScores:(programId)=>{
      actions.fetchScores(dispatch, programId);
    }
    
  };
};

export default connect(mapStateToProps, undefined, mergeProps)(RedeemContent);
